import React, { Fragment } from 'react'
import Navbar from '../../components/Navbar/Navbar'
import Logo from '../../images/logo-01.png'
import Phone from '../../images/telephone.svg'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar';
import CursorMaus from '../../components/CursorMaus/CursorMaus';
import AboutPage from '../../components/about/about';
import WhytoChoose from '../AboutPage/WhytoChoose'
import ProjectSection from '../../components/ProjectSection/ProjectSection'
import CallToAction from '../AboutPage/CallToAction'
import Footer from '../../components/footer/Footer'

function About() {
  return (
    <div>
      
    <Fragment>
        <Navbar Logo={Logo} telephone={Phone} hclass={"wpo-site-header s3"} />
          <PageTitle pageTitle={'About Us'} pagesub={'About'} />

           <AboutPage />
        <WhytoChoose/>

        <ProjectSection/>

        <CallToAction/>

            <Footer/>

        <Scrollbar/>
        <CursorMaus/>



    </Fragment>


    </div>
  )
}

export default About
